import React from 'react'
import PropTypes from 'prop-types'

import numberFormatter from 'services/formatters/numberFormatter'
import percentFormatter from 'services/formatters/percentFormatter'
import AutoSizeChart from 'components/AutoSizeChart'

function RoisDistributionChart(props) {
  const {
    option: optionProp = {},
    ...otherProps,
  } = props

  const option = {
    ...optionProp,
    title: {
      left: 'center',
      ...optionProp.title
    },
    grid: {
      top: 96,
      ...optionProp.grid
    },
    legend: {
      top: 32,
      ...optionProp.legend
    },
    series: {
      type: 'pie',
      radius: [0, '48%'],
      center: ['50%', '52%'],
      label: {
        normal: {
          show: true,
          formatter(params) {
            const {
              value,
              percent
            } = params

            return `${percentFormatter(percent)}\n${numberFormatter(value)}`
          }
        }
      },
      ...optionProp.series
    }
  }

  const media = [{
    query: {
      maxWidth: 288
    },
    option: {
      grid: {
        top: 118
      }
    }
  }]

  return (
    <AutoSizeChart
      {...otherProps}
      option={option}
      media={media}
    />
  )
}

if (process.env.NODE_ENV !== 'production') {
  RoisDistributionChart.propTypes = {
    option: PropTypes.object
  }
}

export default RoisDistributionChart



// WEBPACK FOOTER //
// ./src/scenes/Main/components/RoisDistributionChart/RoisDistributionChart.js